import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";

const Terms = () => {
  return (
    <div className="wrapper_terms_policy">
      <Header />
      <section className="wrap_heading">
        <div className="container">
          <div className="title_wrap">
            <h1>Terms & Conditions</h1>
          </div>
        </div>
      </section>
      <section className="wrap_txt">
        <div className="container">
          <iframe
            src="https://thegodide.com/godide-admin/content-reader?type=terms"
            frameborder="0"
          ></iframe>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Terms;
